export const FETCH_KIBANA_CONFIG = 'src/Corporate/Kibana/action/Fetch_Kibana_Config';
export const FETCH_KIBANA_CONFIG_SUCCESS = 'src/Corporate/Kibana/action/Fetch_Kibana_Config_Success';
export const FETCH_KIBANA_CONFIG_FAILURE = 'src/Corporate/Kibana/action/Fetch_Kibana_Config_Failure';


export const fetchKibanaConfig = (data) =>{
    return {
        type: FETCH_KIBANA_CONFIG,
        data
    }
}

export const fetchKibanaConfigSuccess = (data) =>{
    return {
        type: FETCH_KIBANA_CONFIG_SUCCESS,
        data
    }
}
export const fetchKibanaConfigFailure = (data) =>{
    return {
        type: FETCH_KIBANA_CONFIG_FAILURE,
        data
    }
}